export default __webpack_public_path__ + "media/vendors/app_store_download-9c2a57b7.svg";